/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck bender-url isn't supported in TypeScript yet
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { List } from 'foundations-components/transitional/components/List';
import COMMERCE_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/CommerceHub.svg';
import CONTENT_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/ContentHub.svg';
import OPERATIONS_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/DataHub.svg';
import MARKETING_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/MarketingHub.svg';
import SALES_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/SalesHub.svg';
import SERVICE_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/ServiceHub.svg';
import { FeaturesLayoutUI } from '../../../../components/merch-card/features-display/FeaturesLayoutUI';

// NOTE: This component is a rewrite of the original SuiteFeatures for free tools page
// It assumes ungated access to inbound25 and commerce hub features
// All PP-lib dependencies have been removed
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// TODO: This is a temporary solution to get the product icon for the suite features
const ProductIcon = ({
  name,
  iconStyle
}) => {
  const getIconSrc = () => {
    switch (name) {
      case 'MARKETING':
        return MARKETING_HUB_ICON;
      case 'SALES':
        return SALES_HUB_ICON;
      case 'SERVICE':
        return SERVICE_HUB_ICON;
      case 'CMS':
        return CONTENT_HUB_ICON;
      case 'OPERATIONS':
        return OPERATIONS_HUB_ICON;
      case 'COMMERCE':
        return COMMERCE_HUB_ICON;
      default:
        return null;
    }
  };
  const iconSrc = getIconSrc();
  if (!iconSrc) return null;
  return /*#__PURE__*/_jsx("img", {
    src: iconSrc,
    alt: `${name} Hub`,
    style: {
      width: (iconStyle === null || iconStyle === void 0 ? void 0 : iconStyle.blockSize) || '32px',
      height: (iconStyle === null || iconStyle === void 0 ? void 0 : iconStyle.blockSize) || '32px',
      marginInlineEnd: (iconStyle === null || iconStyle === void 0 ? void 0 : iconStyle.marginInlineEnd) || '12px',
      flexShrink: 0
    }
  });
};
export const SuiteFeatures = ({
  productLevel,
  loading,
  isCollapsible = false
}) => {
  const DisplayedProductLines = ['MARKETING', 'SALES', 'SERVICE', 'CMS', 'OPERATIONS', 'COMMERCE'];
  const getHeaderTranslationKey = level => {
    switch (level) {
      case 'FREE':
        return 'pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.free.includes';
      case 'STARTER':
        return 'pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.starter.includes';
      case 'PROFESSIONAL':
        return 'pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.professional.lowerTierPlus';
      case 'ENTERPRISE':
        return 'pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.enterprise.lowerTierPlus';
      default:
        return 'pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.free.includes';
    }
  };
  const getFeatureTranslationKey = (level, line) => {
    const levelKey = level.toLowerCase();
    const lineKey = line.toLowerCase();
    return `pricing-pages-ui.merchCardsV2.priorityFeatures.suiteFeatures.${levelKey}.${lineKey}.title`;
  };
  const HeaderSection = /*#__PURE__*/_jsx(FormattedMessage, {
    message: getHeaderTranslationKey(productLevel)
  });
  const FeaturesListSection = /*#__PURE__*/_jsx(List, {
    children: DisplayedProductLines.map((productLine, index) => {
      return /*#__PURE__*/_jsxs(Flex, {
        marginBlockStart: index > 0 ? '300' : undefined,
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(ProductIcon, {
          name: productLine,
          iconStyle: {
            blockSize: '32px',
            marginInlineEnd: '12px'
          }
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Text, {
            typography: productLevel !== 'FREE' ? 'body-125' : undefined,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: getFeatureTranslationKey(productLevel, productLine)
            })
          })
        })]
      }, productLine);
    })
  });
  return /*#__PURE__*/_jsx(FeaturesLayoutUI, {
    loading: loading,
    HeaderSection: HeaderSection,
    FeaturesListSection: FeaturesListSection,
    isCollapsible: isCollapsible
  });
};